export const getDisplaySrc = (x) => {
    return x.src&&(x.src.indexOf('data:image') > -1 || x.src.indexOf('http') > -1 || x.src.indexOf('blob:') > -1) ? x.src : (global.config.static_file_server_path + x.src);
};